// :: bus
// :: Global bus service to pass data that does not need to be in the store
import Vue from "vue";

const EventBus = new Vue();

export default EventBus;
